import {
    Box,
    Divider,
    Heading,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay, Text, useMediaQuery,
    VStack
} from "@chakra-ui/react";
import {InputLabel} from "../../index";
import React from "react";
import {useForm} from "react-hook-form";
import {ReactComponent as RightArrow} from "../../../assets/icons/profile/angle-right_neutral.svg";
import {ReactComponent as QuestionIcon} from "../../../assets/icons/question-circle.svg";
import {ReactComponent as ChatQuestion} from "../../../assets/icons/chat-question.svg";
import {ReactComponent as LightIcon} from "../../../assets/icons/lightbulb.svg";
import {ReactComponent as Stepper} from "../../../assets/icons/profile/stepper_frame_order.svg";
import {ReactComponent as StepperMobile} from "../../../assets/icons/profile/stepper_frame_order_mobile.svg";


export const OrderWithdrawModal = ({isOpen, onClose}) => {
    const [isMobile] = useMediaQuery("(max-width: 668px)");

    const {
        register,
        handleSubmit,
        reset,
        formState: {errors, isValid}
    } = useForm({
        mode: "onTouched",
        defaultValues: {
            email: '',
            phone: '',
            telegramNic: '',
        }
    })

    const submit = () => {

    }


    return (
        <Modal
            isCentered
            isOpen={isOpen}
            onClose={onClose}>
            <ModalOverlay/>
            <ModalContent
                maxH={'800px'}
                overflowY={'scroll'}
                borderRadius={'8px'}
                bg={'neutral.1100'}>
                <ModalHeader
                    color={'neutral.100'}
                    fontSize={'heading.xl'}>
                    Create an Alert
                </ModalHeader>
                <ModalCloseButton color={'neutral.500'}/>
                <ModalBody py={'24px'}>
                    <form onSubmit={handleSubmit(submit)}>
                        <HStack
                            alignItems={'start'}>
                            <Box>
                                {isMobile ? <StepperMobile /> : <Stepper />}
                            </Box>
                            <VStack
                                gap={isMobile ? '36px':'86px'}
                                w={'full'}>
                                <Box w={'full'}>
                                    <Text color={'#FCFCFD'} mb={isMobile ? '16px':'32px'}>Crypto</Text>
                                    <InputLabel
                                        bg={'neutral.900'}
                                        height={isMobile ? '40px' : '52px'}
                                        placeholder={'USDT Tether'}
                                    />
                                </Box>
                                <Box w={'full'}>
                                    <Text color={'#FCFCFD'} mb={isMobile ? '16px':'32px'}>Network</Text>
                                    <InputLabel
                                        bg={'neutral.900'}
                                        height={isMobile ? '40px' : '52px'}
                                        placeholder={'USDT Tether'}
                                    />
                                </Box>
                                <Box
                                    mt={isMobile ? '8px':'13px'}
                                    w={'full'}>
                                    <Text color={'#FCFCFD'} mb={isMobile ? '16px':'32px'}>Amount</Text>
                                    <InputLabel
                                        bg={'neutral.900'}
                                        height={isMobile ? '40px' : '52px'}
                                        placeholder={'USDT Tether'}
                                    />
                                </Box>
                                <Box
                                    w={'full'}>
                                    <Text color={'#777E90'} mb={isMobile ? '16px':'32px'}>Wallet address</Text>
                                    <InputLabel
                                        bg={'neutral.900'}
                                        height={isMobile ? '40px' : '52px'}
                                        placeholder={'Input wallet address'}
                                    />
                                </Box>
                            </VStack>
                        </HStack>
                    </form>
                    <VStack
                        mt={'32px'}
                        mx={'auto'}
                        color={'neutral.100'}
                        align={'start'}
                        gap={'24px'}>
                        <HStack>
                            <LightIcon />
                            <Heading fontSize={isMobile ? 'heading.xl' :'heading.2xl'}>Tips</Heading>
                        </HStack>
                        <Divider borderColor={'neutral.800'}/>
                        <Text color={'neutral.500'}>
                            For the safety of your funds, our customer support team may contact you by phone to confirm your
                            withdrawal
                        </Text>
                        <Text color={'neutral.500'}>
                            For the safety of your funds, our customer support team may contact you by phone to confirm your
                            withdrawal
                        </Text>
                        <Text color={'neutral.500'}>
                            For the safety of your funds, our customer support team may contact you by phone to confirm your
                            withdrawal
                        </Text>
                        <HStack
                            mt={'36px'}
                            w={'full'}
                            justifyContent={'space-between'}>
                            <HStack>
                                <QuestionIcon />
                                <Text fontSize={'body.lg'}>FAQs</Text>
                            </HStack>
                            <HStack fontSize={'body.xs'} color={'neutral.500'}>
                                <Text>View More</Text>
                                <RightArrow />
                            </HStack>
                        </HStack>
                        <Divider borderColor={'neutral.800'}/>
                        <HStack w={'full'} color={'neutral.500'}>
                            <ChatQuestion />
                            <Text fontSize={'body.lg'}>How long do withdrawals take?</Text>
                        </HStack>
                        <HStack w={'full'} color={'neutral.500'}>
                            <ChatQuestion />
                            <Text fontSize={'body.lg'}>Why was my withdrawal rejected?</Text>
                        </HStack>
                        <HStack w={'full'} color={'neutral.500'}>
                            <ChatQuestion />
                            <Text fontSize={'body.lg'}>Can I cancel a withdrawal?</Text>
                        </HStack>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}